import groove from 'api/groove'
import { oauthTokenSelector } from 'selectors/app'
import { selectHasLoadedAll } from '../selectors'
import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_RESPONSE,
  FETCH_TICKETS_ERROR,
} from '../types'

export function doLoadRecentTickets(customerId, options = {}) {
  return doLoadTickets(customerId, { perPage: 4, ...options })
}

export function doLoadAllRecentTickets(customerId) {
  return doLoadTickets(customerId, { perPage: 50 })
}

function doLoadTickets(customerId, { perPage, page = 1, silent }) {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const hasLoadedAll = selectHasLoadedAll(state, customerId)

    if (hasLoadedAll) return

    dispatch(doLoadRecentTicketsRequest(customerId, silent))

    groove
      .get(token, 'v1/tickets/search', {
        customer: customerId,
        per_page: perPage,
        page,
        order: 'updated_at desc',
      })
      .then(result => {
        const {
          tickets: rawTickets,
          meta: { pagination },
        } = result.json

        const loadedAll =
          pagination.current_page === pagination.total_pages ||
          pagination.current_page * perPage >= 50

        const tickets = rawTickets.map(ticket => ({
          id: parseInt(ticket.number, 10),
          // Has to be snoozed_until because its loading directly from the api
          state: ticket.snoozed_until ? 'snoozed' : ticket.state,
          title: ticket.title,
        }))

        dispatch(doLoadRecentTicketsResponse(customerId, tickets, loadedAll))
      })
      .catch(err => {
        dispatch(doLoadRecentTicketsError(err))
      })
  }
}

function doLoadRecentTicketsRequest(customerId, silent) {
  return {
    type: FETCH_TICKETS_REQUEST,
    payload: {
      customerId,
      silent,
    },
  }
}

function doLoadRecentTicketsResponse(customerId, tickets, loadedAll) {
  return {
    type: FETCH_TICKETS_RESPONSE,
    payload: {
      customerId,
      tickets,
      loadedAll,
    },
  }
}

function doLoadRecentTicketsError(error) {
  return {
    type: FETCH_TICKETS_ERROR,
    payload: {
      error,
    },
  }
}
